import React from 'react';
import { useTheme } from '@mui/material/styles';
import PanelAlert from '../../../shared/components/PanelAlert';

/**
 * Edit Panel Alert Component (Metadata Editing)
 * Shows selection info and metadata consistency status
 */
const EditPanelAlert = ({ selectedRows, selectedUploadRows, variedFields }) => {
  const theme = useTheme();
  const totalSelected = selectedRows.length + selectedUploadRows.length;

  const getPrimaryMessage = () => {
    if (totalSelected === 0) {
      return 'Select structures to edit metadata';
    }
    
    let message = `${totalSelected} structure${totalSelected !== 1 ? 's' : ''} selected`;
    if (selectedRows.length > 0 && selectedUploadRows.length > 0) {
      message += ` (${selectedRows.length} existing, ${selectedUploadRows.length} pending upload)`;
    }
    return message;
  };

  const getSecondaryMessage = () => {
    if (totalSelected === 0) {
      return 'Fields locked until selection';
    }
    if (variedFields && variedFields.size > 0) {
      return `${variedFields.size} field${variedFields.size !== 1 ? 's have' : ' has'} varied values across selections`;
    }
    return 'All selected structures have consistent metadata values';
  };

  return (
    <PanelAlert
      severity={totalSelected > 0 ? "info" : "warning"}
      primaryMessage={getPrimaryMessage()}
      secondaryMessage={getSecondaryMessage()}
      sx={{
        mx: theme.spacing(2),
        mt: theme.spacing(2),
        mb: theme.spacing(1.5)
      }}
    />
  );
};

export default EditPanelAlert;